<header class="header">
  <!-- header upper section start -->
  <div *ngIf="showUpperHeader" fxLayout="row" fxLayoutAlign="space-between center" class="header-upper-portion">
    <img class="logo" src="./assets/images/header/intellija-logo.png"
      (click)="isDashboardPage ? onLogoClick() : $event.preventDefault()"
      [customTooltip]="isDashboardPage ? 'Reload' : ''" [ngStyle]="{cursor: isDashboardPage ? 'pointer' : 'default'}" />
    <div fxLayout="row" fxLayoutAlign="center center" class="header-top-items">
      <button class="btn-alarm" *ngIf="isDashboardPage || isAlarmsPage" customTooltip="Alarms Toggle"
        [disabled]="isAdminView && (!allFeaturesNames.includes('alarms-view') || !isSuperAdmin)"
        (click)="onAlarmsToggle.emit(); alarmToggle()">
        <mat-icon [ngStyle]="{'color': isAlarmsPage ? '#4361EE' : ''}">alarm</mat-icon>
      </button>
      <button class="btn-notifications" customTooltip="Notifications" [matBadge]="notifications.length"
        [matMenuTriggerFor]="notification">
        <mat-icon> notifications_none </mat-icon>
      </button>
      <mat-menu #notification="matMenu" class="notification-menu">
        <ng-container *ngIf="notifications.length; else noNotification">
          <span style="display: flex;" *ngFor="let notification of notifications">
            <mat-icon style="margin-top: 20px; margin-left: 10px;">notifications_none</mat-icon>
            <p>{{notification.content}} </p>
          </span>
        </ng-container>
        <ng-template #noNotification>
          <ul class="no-notification"> No record available </ul>
        </ng-template>
        <button mat-raised-button class="btn-show-notification">
          <span>Show Notification</span>
        </button>
      </mat-menu>

      <!-- profile icon start -->
      <button [matMenuTriggerFor]="profile" mat-icon-button customTooltip="Profile Settings" class="profile-image">
        <img src="./assets/images/header/person.png" alt="Profile Image">
      </button>
      <mat-menu #profile="matMenu" class="profile-menu">
        <span class="profile-user" (click)="$event.stopPropagation()">
          <p><span>{{ userInfo.userName }}</span></p>
          <p><span class="user-email-text">{{ userInfo.email }} </span></p>
          <hr />
        </span>

        <button mat-menu-item class="profile-menu-item">
          <mat-icon class="mat-menu-icon">account_circle</mat-icon>
          <span>Account </span>
        </button>

        <button mat-menu-item class="profile-menu-item" (click)="$event.stopPropagation()">
          <img class="mat-menu-icon svg-size" src="../../../../assets/icons/notification.svg">
          <span>Disable Notification</span>
          <mat-slide-toggle class="profile-toggle" color="primary" (click)="profile.closed.emit()"></mat-slide-toggle>
        </button>

        <button mat-menu-item class="profile-menu-item" (click)="$event.stopPropagation()">
          <img class="mat-menu-icon svg-size" src="../../../../assets/icons/admin.svg">
          <span>Admin View</span>
          <span class="hint">(F1)</span>
          <mat-slide-toggle [formControl]="isAdminSide" color="primary" class="profile-toggle" (click)="profile.closed.emit()">
          </mat-slide-toggle>
        </button>

        <button mat-menu-item class="profile-menu-item" (click)="$event.stopPropagation()">
          <img class="mat-menu-icon svg-size" src="../../../../assets/icons/light-mode.svg">
          <span >Light Mode</span>
          <span class="hint">(F2)</span>
          <mat-slide-toggle [formControl]="isLightMode" color="primary" (change)="onLightModeChange($event.checked); profile.closed.emit()" class="profile-toggle">
          </mat-slide-toggle>
        </button>

        <!-- select language -->
        <button mat-menu-item [matMenuTriggerFor]="levelOne">
          <div fxLayout="row" fxLayoutAlign="start center">
            <mat-icon class="mat-menu-icon">language</mat-icon>
            <span> Language </span>
            <img src="./assets/images/header/{{ selectedCountryLang.code | lowercase }}.png" class="m-l-10 flag-icon">
          </div>
        </button>
        <mat-menu class="language-menu" #levelOne="matMenu" direction="down" yPosition="below">
          <button mat-menu-item *ngFor="let countryLanguage of countriesLanguages"
            (click)="onCountrySelection(countryLanguage.code)">
            <div fxLayout="row" fxLayoutAlign="start center">
              <mat-icon class="mat-menu-icon">language</mat-icon>
              <span>{{ (countryLanguage.name !== 'US English') ? countryLanguage.name : countryLanguage.name + '
                (Default)' }} </span>
              <img src="./assets/images/header/{{ countryLanguage.code | lowercase }}.png" class="flag-icon">
            </div>
          </button>
        </mat-menu>
        <!-- <button mat-menu-item class="profile-menu-item">
          <mat-icon class="mat-menu-icon">settings</mat-icon>
          <span>Settings</span>
        </button> -->
        <button mat-menu-item class="profile-menu-item" [matMenuTriggerFor]="searchCountry">
          <mat-icon class="mat-menu-icon">timelapse</mat-icon>
          <span> Timezone <span class="hint">({{ selectedTimeZoneValue }})</span></span>
        </button>

        <mat-menu (click)="$event.stopPropagation()" class="language-menu" #searchCountry="matMenu" direction="down"
          yPosition="before">
          <div (click)="$event.stopPropagation()" class="time-zone-section">
            <mat-form-field appearance="outline">
              <mat-label class="time-zone-label"> Time Zone</mat-label>
              <input type="text" (focusout)="onTimezoneFocusOut()" (click)="$event.stopPropagation()"
                [formControl]="selectedTimezoneName" matInput [matAutocomplete]="auto" class="selected-timezone-text" />
              <mat-autocomplete (optionSelected)="onTimezoneSelection($event.option.value); profile.closed.emit();" #auto="matAutocomplete">
                <mat-option class="time-zone-options" *ngFor="let filteredTimeZone of filteredTimeZones | async"
                  [value]="filteredTimeZone.name">
                  <div class="timezone-list">
                    <span>{{ filteredTimeZone.name }}</span>
                    <div> <span class="timezone"> {{ filteredTimeZone?.offset }} </span> </div>
                  </div>
                </mat-option>

              </mat-autocomplete>
            </mat-form-field>
          </div>
        </mat-menu>

        <button mat-menu-item (click)="logOut()" class="profile-menu-item">
          <mat-icon class="mat-menu-icon">exit_to_app</mat-icon>
          <span>Sign Out</span>
        </button>
      </mat-menu>
    </div>
    <!-- profile icon end -->
  </div>
  <!-- header upper section end -->

  <!-- header lower section start -->
  <div fxLayout="row" fxLayoutAlign="space-between center" class="header-lower-portion">
    <button *ngIf="isAlarmsPage" (click)="backToDashboard()" customTooltip="Back to Dashboard"
      class="btn-back-to-dashboard">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div fxLayout="row" fxLayoutAlign="space-between center">

      <button *ngIf="!isAlarmsPage" (click)="leftMenuToggle()" class="menu-icon">
        <mat-icon>menu</mat-icon>
      </button>

      <!-- EYE ICON (perspectives menu) -->
      <button *ngIf="isDashboardPage" [matMenuTriggerFor]="perspectiveMenu" customTooltip="Perspectives"
        class="eye-icon">
        <mat-icon>remove_red_eye</mat-icon>
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
      <mat-menu #perspectiveMenu="matMenu" class="menu-container">
        <span mat-menu-item *ngFor="let perspective of allPerspectives" (click)="perspectiveSelected(perspective.name)">
          <span> {{ perspective.name }} </span>
          <mat-icon (click)="$event.stopPropagation(); setDefaultPerspective(perspective.id)"
            [customTooltip]="(perspective.name !== selectedPerspective?.name) ? 'Set as Default' : ''"
            [ngStyle]="{color: (perspective.isDefaultPerspective) ? '#4361EE' : ''}"
            [ngClass]="{'perspective-default-icon': !perspective.isDefaultPerspective, 'already-default-perspectve-icon': perspective.isDefaultPerspective }">
            star_border
          </mat-icon>
        </span>
      </mat-menu>

      <!-- dashboard menu button start -->
      <div *ngIf="isDashboardPage" fxLayout="row" fxLayoutAlign="center center">
        <button [matMenuTriggerFor]="dashboardMenu" customTooltip="Dashboards" [disabled]="!allDashboards.length"
          class="dashboard-menu-btn">
          <div fxLayout="row" fxLayoutAlign="center center">
            <mat-icon>dashboard</mat-icon>
            <span class="dashboard-menu-text"> Dashboard</span>
          </div>
        </button>
      </div>
      <mat-menu class="dashboard-menu" #dashboardMenu="matMenu" direction="down" yPosition="below">
        <div *ngFor="let menuItem of allDashboards">
          <div *ngIf="menuItem.path === '' " fxLayout="row" fxLayoutAlign="space-between center">
            <button mat-menu-item (click)="onDashboardMenuItemClick(menuItem.id)">
              {{menuItem.name}}
              <div>
                <mat-icon class="icon" [ngStyle]="{color: (selectedDashboardName === menuItem?.name) ? '#4361EE' : ''}">
                  star_border</mat-icon>
                <mat-icon class="icon">push_pin</mat-icon>
              </div>
            </button>
          </div>
        </div>

        <ng-container *ngFor="let dashboard of dashboardsWithChildren">
          <span (mouseleave)="levelOneTrigger.closeMenu()"> </span>
          <div *ngIf="dashboard.path !== '' ">
            <li mat-menu-item [matMenuTriggerFor]="levelOneDashBoard">
              <span>{{ dashboard.path }}</span>
            </li>
            <mat-menu class="dashboard-menu" #levelOneDashBoard="matMenu">
              <div *ngFor="let child of dashboard.children">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                  <button mat-menu-item (click)="onDashboardMenuItemClick(child.id)"> {{ child.name }}
                    <div>
                      <mat-icon class="icon"
                        [ngStyle]="{color: (selectedDashboardName === child?.name) ? '#4361EE' : ''}">star_border
                      </mat-icon>
                      <mat-icon class="icon">push_pin</mat-icon>
                    </div>
                  </button>
                </div>
              </div>
            </mat-menu>
          </div>
        </ng-container>
      </mat-menu>
      <!-- dashboard menu button end -->
    </div>

    <div *ngIf="isDashboardPage && !allDashboards.length && !dashboardsWithChildren.length">
      <span class="info-message">No Dashboard Exists!</span>
    </div>

    <div *ngIf="isDashboardPage || isAlarmsPage" fxLayout="row" fxLayoutAlign="space-between center">
      <div *ngIf="allDashboards.length && selectedDashboardName && isDashboardPage" fxLayout="row"
        fxLayoutAlign="space-between center">
        <button *ngIf="isTSCallExists" [matMenuTriggerFor]="tsDataMenu" class="ts-range-menu">
          <div fxLayout="row" fxLayoutAlign="space-between center" class="ts-range-dropdown-section">
            <mat-icon style="margin-right: 5px;">access_time</mat-icon>
            <span class="ts-range-text" [customTooltip]="customTSTooltip()" (click)="openRangeForm()">{{
              rangeForm.get('range').value ? selectedRangeName : 'Custom Range' }} <span style="color: #D9731C;"
                *ngIf="selectedTimeZoneValue && selectedTimeZoneValue !== 'Local browser time'"> {{
                selectedTimeZoneValue }} </span> </span>
            <mat-icon style="color: 24292E;">keyboard_arrow_down</mat-icon>
          </div>
        </button>

        <button class="btn-range-change" *ngIf="!rangeForm.get('range').value"
          [disabled]="!startDate && !rangeForm.get('fromDate').value" (click)="onTSSpanChange('backward')">
          <mat-icon class="header-icon time-range" customTooltip="Back Time-Range">arrow_back</mat-icon>
        </button>
        <button class="btn-range-change" *ngIf="!rangeForm.get('range').value"
          [disabled]="checkForwardValidation || (!endDate && !rangeForm.get('toDate').value)"
          (click)="onTSSpanChange('forward')">
          <mat-icon class="header-icon time-range" customTooltip="Forward Time-Range">arrow_forward</mat-icon>
        </button>

        <!-- #menu="matMenu" -->
        <mat-menu #tsDataMenu="matMenu" class="calenderMenu time-series-duration-menu">
          <div fxLayout="row" style="display: flex" (click)="$event.stopPropagation()">
            <div class="range-form-section">
              <form [formGroup]="rangeForm">
                <span class="p-t-30" class="abs-time-range"> Absolute Time Range </span>
                <P><span style="margin-top: 33px" class="time-range-fields"> From </span></P>
                <div class="input-container">
                  <input matInput class="input-field" [ngxMatDatetimePicker]="pickerFrom"
                    (dateChange)="onFromDateChange($event.value)" (input)="onFromDateChange($event.target.value)"
                    formControlName="fromDate" [min]="minDateFrom" [max]="maxDateFrom"
                    (click)="$event.stopPropagation()">
                  <button class="icon-button">
                    <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                    <ngx-mat-datetime-picker #pickerFrom [showSpinners]="showSpinners" [showSeconds]="showSeconds"
                      [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond" [touchUi]="touchUi"
                      [enableMeridian]="enableMeridian">
                    </ngx-mat-datetime-picker>
                  </button>

                </div>

                <p><span class="time-range-fields"> To </span></p>
                <div class="input-container">
                  <input matInput class="input-field" [ngxMatDatetimePicker]="pickerTo"
                    (dateChange)="onToDateChange($event.value)" (input)="onToDateChange($event.target.value)"
                    (focusOut)="$event.preventDefault()" formControlName="toDate" [min]="minDateTo" [max]="maxDateTo"
                    (click)="$event.stopPropagation()">
                  <button class="icon-button">
                    <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                    <ngx-mat-datetime-picker #pickerTo [showSpinners]="showSpinners" [showSeconds]="showSeconds"
                      [stepHour]="stepHour" [stepMinute]="stepMinute" [stepSecond]="stepSecond" [touchUi]="touchUi">
                    </ngx-mat-datetime-picker>
                  </button>
                </div>

                <button mat-raised-button (click)="submitTSRange()" [disabled]="rangeForm.invalid" color="primary"
                  class="btn-apply-ts-range">Apply The Range </button>
              </form>

            </div>
            <div class="ranges">
              <span mat-menu-item *ngFor="let range of ranges"
                (click)="$event.stopPropagation(); onRangeChange(range.value, range.name); submitTSRange();"
                [ngClass]="rangeForm?.get('range')?.value == range.value ? 'range-names' : ''"> {{range.name}} </span>
            </div>
          </div>

          <div class="browser-time-section">
            <span class="browser-time">Browser Time <span>Egypt EET </span> </span>
            <div class="timezone"> <span> UTC +3.00</span> </div>
          </div>
        </mat-menu>

        <button *ngIf="isTSCallExists" (click)="zoomoutLineCharts()" customTooltip="Reset Range"
          class="icon-button-simple btn-reset">
          <mat-icon>zoom_out</mat-icon>
        </button>

        <button (click)="onRefreshDashboard()" customTooltip="Refresh Dashboard"
          class="icon-button-simple refresh-dashboard">
          <mat-icon>refresh</mat-icon>
        </button>

        <button *ngIf="isLiveDataCallExists" [matMenuTriggerFor]="liveDataMenu" customTooltip="Live-Data Interval"
          class="live-data-time-menu">
          <span *ngIf="selectedInterval"> {{ selectedInterval }}</span>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>

        <!-- #menu="matMenu" -->
        <mat-menu #liveDataMenu="matMenu" class="interval-menu">
          <span mat-menu-item class="time" *ngFor="let refreshInterval of refreshIntervals"
            (click)="onLiveIntervalChange(refreshInterval.value)">
            {{ refreshInterval.name}}</span>
        </mat-menu>

      </div>

      <div *ngIf="isAlarmsPage" fxLayout="row" fxLayoutAlign="space-between center">
        <button (click)="onRefreshAlarms()" customTooltip="Refresh Dashboard" class="icon-button-simple">
          <mat-icon>refresh</mat-icon>
        </button>
        <button [matMenuTriggerFor]="timeMenu2" customTooltip="Live-Data Interval" class="live-data-time-menu">
          <span *ngIf="selectedInterval"> {{ selectedInterval }}</span>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <!-- #menu="matMenu" -->
        <mat-menu #timeMenu2="matMenu" class="interval-menu">
          <span mat-menu-item class="time" *ngFor="let refreshInterval of refreshIntervals"
            (click)="onLiveIntervalChange(refreshInterval.value)">
            {{ refreshInterval.name}}</span>
        </mat-menu>
      </div>

      <span class="vertical-bar" *ngIf="isTSCallExists || isLiveDataCallExists || isAlarmsPage"> </span>

      <mat-icon *ngIf="!showUpperHeader" (click)="fullScreenExit()" customTooltip="Exit Full-Screen"
        class="header-icon exit-full-screen">fullscreen_exit
      </mat-icon>

      <mat-icon class="header-icon hide-header" (click)="hideUpperHeader()"
        [customTooltip]="showUpperHeader ? 'Hide Top-Header' : 'Show Top-Header'"
        [ngStyle]="{transform: !showUpperHeader ? 'rotate(180deg)' : ''}">
        keyboard_arrow_up</mat-icon>
    </div>
  </div>
  <!-- header lower section end -->

</header>